import { styled } from 'goober'

/**
 * Since it's pretty hard to edit the input directly without recreating it,
 * some padding would make it a bit nicer
 */
export const InputSpacingWrapper = styled('span')`
  margin: .15em .6em .05em .6em;
`

export const InputSeparator = styled('span')`
  font-weight: bold;
`

export const Heading = styled('div')`
  padding: 0.4em;
`
